import React, {Component} from 'react';
import './GerberReviewPage.css';
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../configuration";
import InitialQuotationState from "../../QuotationForm/InitialQuotationState";

let gerberImgUrl = null;

let zoomIncrement = 0;
let zoomSize = 0;
let zoomStyle;
let divPaddingScrolling = {
    // padding: 100,
    'padding-left': 100,
    'padding-right': 100,
    'padding-top': 68,
    'padding-bottom': 68
};
let a = 0;


class GerberReviewPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            TP: 'T',
            color: 'Green',
            surface: '1',
            gerberImg: '',
            gLayers: '',
            gLength: '',
            gWidth: '',
            zoom: '',
            divPadding: ''
        };
        this.top = this.top.bind(this);
        this.bottom = this.bottom.bind(this);
        this.getGerberImage = this.getGerberImage.bind(this);
        this.colorChange = this.colorChange.bind(this);
        this.surfaceChange = this.surfaceChange.bind(this);
        this.changeGerberImage = this.changeGerberImage.bind(this);
        this.dragImage = this.dragImage.bind(this);
        this.scroll = this.scroll.bind(this);
        // this.getGerberImage(localStorage.getItem("igd"))
    }

    componentDidMount() {
        let igdto = JSON.parse(localStorage.getItem("igdto"));
        document.getElementById('topBtn').style.color = '#0099ff';
        this.setState({
            gLength: igdto.length,
            gWidth: igdto.width,
            gLayers: igdto.layers
        }, () => {
            this.getGerberImage(localStorage.getItem("igd"));
        });

    }

    top = (event) => {
        this.setState({
            TP: 'T'
        }, () => this.changeGerberImage())
        document.getElementById('topBtn').style.color = '#0099ff';
        document.getElementById('bottomBtn').style.color = '';
    };
    bottom = (event) => {
        this.setState({
            TP: 'B'
        }, () => this.changeGerberImage());
        document.getElementById('bottomBtn').style.color = '#0099ff';
        document.getElementById('topBtn').style.color = '';
    };
    colorChange = (event) => {
        this.setState({
            color: event.target.value
        }, () => this.changeGerberImage());
    };
    surfaceChange = (event) => {
        this.setState({
            surface: event.target.value
        }, () => this.changeGerberImage());
    };
    scroll = (event) => {

        event.preventDefault();

        if (event.deltaY > 0 && zoomIncrement > 0) {
            // zoomout
            zoomIncrement = zoomIncrement - 20;
        } else if (event.deltaY < 0) {
            // zoomin
            zoomIncrement = zoomIncrement + 20;
        }
        divPaddingScrolling = {
            padding: 68 - zoomIncrement
        };
        zoomSize = zoomIncrement;
        zoomStyle = {
            width: 300 + zoomIncrement
        }
        this.setState({
            zoom: zoomStyle,
            divPadding: divPaddingScrolling
        }, () => this.componentDidUpdate())
    };
    dragImage = (event) => {
    }
    changeGerberImage = () => {
        if (this.state.TP === 'T') {
            if (this.state.color === 'Green') {
                this.setState({
                    gerberImg: gerberImgUrl[0]
                })

            }else if (this.state.color === 'Blue') {
                this.setState({
                    gerberImg: gerberImgUrl[1]
                })

            }else if (this.state.color === 'Red') {
                this.setState({
                    gerberImg: gerberImgUrl[2]
                })

            }else if (this.state.color === 'Black') {
                this.setState({
                    gerberImg: gerberImgUrl[3]
                })

            }else if (this.state.color === 'Yellow') {
                this.setState({
                    gerberImg: gerberImgUrl[4]
                })

            }else {
                this.setState({
                    gerberImg: gerberImgUrl[5]
                })

            }
        }else {
            if (this.state.color === 'Green') {
                this.setState({
                    gerberImg: gerberImgUrl[6]
                })

            }else if (this.state.color === 'Blue') {
                this.setState({
                    gerberImg: gerberImgUrl[7]
                })

            }else if (this.state.color === 'Red') {
                this.setState({
                    gerberImg: gerberImgUrl[8]
                })

            }else if (this.state.color === 'Black') {
                this.setState({
                    gerberImg: gerberImgUrl[9]
                })

            }else if (this.state.color === 'Yellow') {
                this.setState({
                    gerberImg: gerberImgUrl[10]
                })

            }else {
                this.setState({
                    gerberImg: gerberImgUrl[11]
                })

            }
        }

    };
    getGerberImage = (gerberDto) => {
        let splitDto = gerberDto.split('image/');
        let axiosConfigForReview = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/gerber/getImage/' + splitDto[1], axiosConfigForReview)
            .then((res) => {
                gerberImgUrl = res.data;
                console.log("GERBER IMAGES ===> ", res.data);
                this.setState({
                    gerberImg: gerberImgUrl[0]
                })
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    componentWillUnmount() {
    }

    render() {
        return (
            <div className='gerber-view-div'>
                <h3 className='gerber-viewer-text-header '>Gerber Viewer</h3>
                <hr/>
                <div className='gerber-view-text-align'>
                    <ul className='gerber_ul3'>
                        <li className='mouse-pointer' id='topBtn' onClick={(event) => this.top(event)}>Top</li>
                        <li className='mouse-pointer' id='bottomBtn' onClick={(event) => this.bottom(event)}>Bottom</li>
                    </ul>
                </div>
                <div className=' mobile-view-show'>
                    <div className=' gerber-div-size-mobile  '>
                        <div
                            id='mydiv'
                            className='   '
                            onWheel={(event) => this.scroll(event)}
                            style={divPaddingScrolling}
                        >
                            <img id='mydivheader'
                                 draggable={true}
                                 className='set-width-gerber-img'
                                // onWheel={(event) => this.scroll(event)}
                                 style={zoomStyle} src={this.state.gerberImg} alt="kitcut_gerber_img"/>
                        </div>
                    </div>
                </div>
                <div className='col-md-12 custom-col-12 align-content bottom-margin-gerber-view'>
                    <div className='col-md-8  custom-col-12 mobile-view-hide '>
                        <div
                            id='mydiv'
                            className='div-border div-padding gerber-div-size div-overflow'
                            onWheel={(event) => this.scroll(event)}
                            style={divPaddingScrolling}
                        >
                            <img id='mydivheader'
                                 draggable={true}
                                 className='set-width-gerber-img'
                                // onWheel={(event) => this.scroll(event)}
                                 style={zoomStyle} src={this.state.gerberImg} alt="kitcut_gerber_img"/>
                        </div>
                    </div>
                    <div className='col-md-4  custom-col-12 remove-padding-mobile'>
                        <div className='div-border div-padding '>
                            <div className='text-align-left font-size-22'>
                                Capabilities
                            </div>
                            <div>
                                <div className='display-inline width-30 text-align-left font-size-14'>PCB Color</div>
                                <div className='display-inline width-70 text-align-right font-size-14'>
                                    <select className='selector-width selector-style' onChange={this.colorChange}>
                                        <option value="Green" className='option-style'>Green</option>
                                        <option value="Blue" className='option-style'>Blue</option>
                                        <option value="Red" className='option-style'>Red</option>
                                        <option value="Black" className='option-style'>Black</option>
                                        <option value="Yellow" className='option-style'>Yellow</option>
                                        <option value="White" className='option-style'>White</option>
                                    </select>
                                </div>
                            </div>
                            <div>
                                <div className='display-inline width-30 text-align-left font-size-14'>Surface Finish
                                </div>
                                <div className='display-inline width-70 text-align-right font-size-14'>
                                    <select className='selector-width selector-style' onChange={this.surfaceChange}>
                                        <option value="1" className='option-style'>HASL(with lead)
                                        </option>
                                        <option value="2" className='option-style'>LeadFree HASL-RoHS
                                        </option>
                                        <option value="3" className='option-style'>ENIG-RoHS
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='div-border  div-padding'>
                            <div className='text-align-left font-size-22'>
                                Analysis Results
                            </div>
                            {this.state.gLayers > 0 ?
                                <p className='text-align-left font-size-14'> layers : {this.state.gLayers}
                                </p>
                                :
                                ''
                            }

                            <p className='text-align-left font-size-14'> minimum trace width : >=10 mil
                            </p>
                            <p className='text-align-left font-size-14'> minimum trace spacing : >=10 mil
                            </p>
                            <p className='text-align-left font-size-14'> minimum drill size : 0.4 mm
                            </p>
                            {this.state.gWidth > 0 ?
                                <p className='text-align-left font-size-14'> width : {this.state.gWidth}
                                </p>
                                : ""
                            }

                            {this.state.gLength > 0 ?
                                <p className='text-align-left font-size-14'> height : {this.state.gLength}
                                </p>
                                : ""
                            }


                        </div>
                        <div className='div-border div-padding'>
                            <div className='text-align-left font-size-22'>
                                Mouse Controls:
                            </div>
                            <p className='text-align-left font-size-14'>move - scroll bar
                            </p>

                            <p className='text-align-left font-size-14'>Zoom - Scroll / Middle mouse button + shift
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default GerberReviewPage;



// WEBPACK FOOTER //
// ./src/components/Site/GerberReview/GerberReviewPage/GerberReviewPage.js